import { render } from "./Actions.vue?vue&type=template&id=10f063a6&scoped=true&lang=pug"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"

import "./Actions.vue?vue&type=style&index=0&id=10f063a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10f063a6"

export default script